var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpense(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-outcome-svgrepo-com (2) 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.4996 4.5C11.9473 4.5 11.4996 4.05228 11.4996 3.5C11.4996 2.94772 11.9473 2.5 12.4996 2.5H20.4996C21.6042 2.5 22.4996 3.39543 22.4996 4.5V12.5C22.4996 13.0523 22.0519 13.5 21.4996 13.5C20.9473 13.5 20.4996 13.0523 20.4996 12.5V5.89343L4.22761 22.1655C3.83709 22.556 3.20393 22.556 2.81341 22.1655C2.42288 21.7749 2.42288 21.1418 2.81341 20.7512L19.0646 4.5H12.4996Z",
    fill: "#304FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpense);
export default __webpack_public_path__ + "static/media/expense.edfb9de404bf7fc6c45bcf201fd448bb.svg";
export { ForwardRef as ReactComponent };